/**
 * @deprecated Use CaseStepBreakdownChart instead. This component is maintained
 * for backward compatibility only and will be removed in a future version.
 */
import React, { useEffect } from 'react';

import { ChartDataItem } from '../../models/ChartTypes';
import { CaseStepBreakdownChart, StepData } from '../Charts/CaseStepBreakdownChart';
import { getActivityColor } from '../../utils/caseUtils';

interface CaseEfficiencyTotalsDesktopProps {
  chartData: ChartDataItem[],
  onSegmentClick: (segment_name: string) => void
}

/**
 * Maps legacy ChartDataItem[] to new StepData[] format.
 */
function mapChartDataToStepData(chartData: ChartDataItem[]): StepData[] {
  return chartData.map(item => ({
    name: item.name,
    time: item.time,
    displayTime: item.displayTime,
    color: getActivityColor(item.name),
  }));
}

/**
 * @deprecated Use CaseStepBreakdownChart instead. This component is maintained
 * for backward compatibility only and will be removed in a future version.
 */
const CaseEfficiencyTotalsDesktop = (
  { chartData, onSegmentClick } : CaseEfficiencyTotalsDesktopProps
): React.JSX.Element => {
  useEffect(() => {
    console.warn('CaseEfficiencyTotalsDesktop is deprecated. Use CaseStepBreakdownChart instead.');
  }, []);

  const stepData = mapChartDataToStepData(chartData);
  const totalTime = stepData.reduce((sum, step) => sum + step.time, 0);
  const totalHours = Math.floor(totalTime / 60);
  const totalMins = Math.floor(totalTime % 60);
  const hourLabel = totalHours === 1 ? 'hr' : 'hrs';
  const minuteLabel = totalMins === 1 ? 'min' : 'mins';
  const totalStepTime = totalHours > 0
    ? `${totalHours} ${hourLabel}${totalMins > 0 ? ` ${totalMins} ${minuteLabel}` : ''}`.trim()
    : `${totalMins} ${minuteLabel}`;

  const handleSegmentClick = (step: StepData): void => {
    onSegmentClick(step.name);
  };

  return (
    <CaseStepBreakdownChart
      data={stepData}
      totalStepTime={totalStepTime}
      onSegmentClick={handleSegmentClick}
    />
  );
};

export default CaseEfficiencyTotalsDesktop;
